import { c as _c } from "react/compiler-runtime";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, alpha, Box, Container, Typography } from "@mui/material";
import React from "react";
import { LandingReveal } from "#/features/homePage/ui/landing/LandingReveal";
import type { TranslationFunctions } from "#/i18n/i18n-types";
export type HomeLandingFaqProps = {
  LL: TranslationFunctions;
};
export const HomeLandingFaq: React.FC<HomeLandingFaqProps> = t0 => {
  const $ = _c(126);
  const {
    LL
  } = t0;
  let t1;
  if ($[0] !== LL) {
    t1 = LL.HOME_FAQ_Q_01();
    $[0] = LL;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== LL) {
    t2 = LL.HOME_FAQ_A_01();
    $[2] = LL;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      q: t1,
      a: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== LL) {
    t4 = LL.HOME_FAQ_Q_02();
    $[7] = LL;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== LL) {
    t5 = LL.HOME_FAQ_A_02();
    $[9] = LL;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = {
      q: t4,
      a: t5
    };
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== LL) {
    t7 = LL.HOME_FAQ_Q_03();
    $[14] = LL;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== LL) {
    t8 = LL.HOME_FAQ_A_03();
    $[16] = LL;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = {
      q: t7,
      a: t8
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== LL) {
    t10 = LL.HOME_FAQ_Q_04();
    $[21] = LL;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== LL) {
    t11 = LL.HOME_FAQ_A_04();
    $[23] = LL;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = {
      q: t10,
      a: t11
    };
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== LL) {
    t13 = LL.HOME_FAQ_Q_05();
    $[28] = LL;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== LL) {
    t14 = LL.HOME_FAQ_A_05();
    $[30] = LL;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = {
      q: t13,
      a: t14
    };
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== LL) {
    t16 = LL.HOME_FAQ_Q_06();
    $[35] = LL;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== LL) {
    t17 = LL.HOME_FAQ_A_06();
    $[37] = LL;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t16 || $[40] !== t17) {
    t18 = {
      q: t16,
      a: t17
    };
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== LL) {
    t19 = LL.HOME_FAQ_Q_07();
    $[42] = LL;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== LL) {
    t20 = LL.HOME_FAQ_A_07();
    $[44] = LL;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t19 || $[47] !== t20) {
    t21 = {
      q: t19,
      a: t20
    };
    $[46] = t19;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== LL) {
    t22 = LL.HOME_FAQ_Q_08();
    $[49] = LL;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== LL) {
    t23 = LL.HOME_FAQ_A_08();
    $[51] = LL;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t22 || $[54] !== t23) {
    t24 = {
      q: t22,
      a: t23
    };
    $[53] = t22;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== LL) {
    t25 = LL.HOME_FAQ_Q_09();
    $[56] = LL;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== LL) {
    t26 = LL.HOME_FAQ_A_09();
    $[58] = LL;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t25 || $[61] !== t26) {
    t27 = {
      q: t25,
      a: t26
    };
    $[60] = t25;
    $[61] = t26;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== LL) {
    t28 = LL.HOME_FAQ_Q_10();
    $[63] = LL;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== LL) {
    t29 = LL.HOME_FAQ_A_10();
    $[65] = LL;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== t28 || $[68] !== t29) {
    t30 = {
      q: t28,
      a: t29
    };
    $[67] = t28;
    $[68] = t29;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== LL) {
    t31 = LL.HOME_FAQ_Q_11();
    $[70] = LL;
    $[71] = t31;
  } else {
    t31 = $[71];
  }
  let t32;
  if ($[72] !== LL) {
    t32 = LL.HOME_FAQ_A_11();
    $[72] = LL;
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  let t33;
  if ($[74] !== t31 || $[75] !== t32) {
    t33 = {
      q: t31,
      a: t32
    };
    $[74] = t31;
    $[75] = t32;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  let t34;
  if ($[77] !== LL) {
    t34 = LL.HOME_FAQ_Q_12();
    $[77] = LL;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  let t35;
  if ($[79] !== LL) {
    t35 = LL.HOME_FAQ_A_12();
    $[79] = LL;
    $[80] = t35;
  } else {
    t35 = $[80];
  }
  let t36;
  if ($[81] !== t34 || $[82] !== t35) {
    t36 = {
      q: t34,
      a: t35
    };
    $[81] = t34;
    $[82] = t35;
    $[83] = t36;
  } else {
    t36 = $[83];
  }
  let t37;
  if ($[84] !== LL) {
    t37 = LL.HOME_FAQ_Q_13();
    $[84] = LL;
    $[85] = t37;
  } else {
    t37 = $[85];
  }
  let t38;
  if ($[86] !== LL) {
    t38 = LL.HOME_FAQ_A_13();
    $[86] = LL;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== t37 || $[89] !== t38) {
    t39 = {
      q: t37,
      a: t38
    };
    $[88] = t37;
    $[89] = t38;
    $[90] = t39;
  } else {
    t39 = $[90];
  }
  let t40;
  if ($[91] !== LL) {
    t40 = LL.HOME_FAQ_Q_14();
    $[91] = LL;
    $[92] = t40;
  } else {
    t40 = $[92];
  }
  let t41;
  if ($[93] !== LL) {
    t41 = LL.HOME_FAQ_A_14();
    $[93] = LL;
    $[94] = t41;
  } else {
    t41 = $[94];
  }
  let t42;
  if ($[95] !== t40 || $[96] !== t41) {
    t42 = {
      q: t40,
      a: t41
    };
    $[95] = t40;
    $[96] = t41;
    $[97] = t42;
  } else {
    t42 = $[97];
  }
  let t43;
  if ($[98] !== t12 || $[99] !== t15 || $[100] !== t18 || $[101] !== t21 || $[102] !== t24 || $[103] !== t27 || $[104] !== t3 || $[105] !== t30 || $[106] !== t33 || $[107] !== t36 || $[108] !== t39 || $[109] !== t42 || $[110] !== t6 || $[111] !== t9) {
    t43 = [t3, t6, t9, t12, t15, t18, t21, t24, t27, t30, t33, t36, t39, t42];
    $[98] = t12;
    $[99] = t15;
    $[100] = t18;
    $[101] = t21;
    $[102] = t24;
    $[103] = t27;
    $[104] = t3;
    $[105] = t30;
    $[106] = t33;
    $[107] = t36;
    $[108] = t39;
    $[109] = t42;
    $[110] = t6;
    $[111] = t9;
    $[112] = t43;
  } else {
    t43 = $[112];
  }
  const items = t43;
  let t44;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = {
      py: {
        xs: 6,
        md: 8
      },
      bgcolor: alpha("#181c1f", 0.72)
    };
    $[113] = t44;
  } else {
    t44 = $[113];
  }
  let t45;
  if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = {
      px: {
        xs: 2,
        sm: 3,
        md: 4
      }
    };
    $[114] = t45;
  } else {
    t45 = $[114];
  }
  let t46;
  if ($[115] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = {
      mb: 1.5
    };
    $[115] = t46;
  } else {
    t46 = $[115];
  }
  let t47;
  if ($[116] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = {
      color: "text.primary"
    };
    $[116] = t47;
  } else {
    t47 = $[116];
  }
  let t48;
  if ($[117] !== LL) {
    t48 = LL.HOME_SECTION_FAQ();
    $[117] = LL;
    $[118] = t48;
  } else {
    t48 = $[118];
  }
  let t49;
  if ($[119] !== t48) {
    t49 = <LandingReveal sx={t46}><Typography id="landing-faq-heading" variant="h3" component="h2" sx={t47}>{t48}</Typography></LandingReveal>;
    $[119] = t48;
    $[120] = t49;
  } else {
    t49 = $[120];
  }
  let t50;
  if ($[121] !== items) {
    t50 = items.map(_temp2);
    $[121] = items;
    $[122] = t50;
  } else {
    t50 = $[122];
  }
  let t51;
  if ($[123] !== t49 || $[124] !== t50) {
    t51 = <Box id="faq" component="section" aria-labelledby="landing-faq-heading" sx={t44}><Container maxWidth="lg" sx={t45}>{t49}{t50}</Container></Box>;
    $[123] = t49;
    $[124] = t50;
    $[125] = t51;
  } else {
    t51 = $[125];
  }
  return t51;
};
function _temp(theme) {
  return alpha(theme.appDesign.surface, 0.88);
}
function _temp2(item, index) {
  return <LandingReveal key={`home-landing-faq-${String(index + 1).padStart(2, "0")}`} sx={{
    mb: 1.25
  }} staggerMs={Math.min(index * 42, 520)}><Accordion disableGutters={true} elevation={0} defaultExpanded={index === 0} sx={{
      bgcolor: _temp,
      border: theme_0 => `1px solid ${alpha(theme_0.appDesign.outline, index === 0 ? 0.2 : 0.12)}`,
      borderRadius: "8px !important",
      "&:before": {
        display: "none"
      },
      overflow: "hidden"
    }}><AccordionSummary expandIcon={<ExpandMore />} sx={{
        fontWeight: 600,
        "& .MuiAccordionSummary-content": {
          my: 1.25
        }
      }}>{item.q}</AccordionSummary><AccordionDetails sx={{
        pt: 0,
        pb: 2,
        color: "text.secondary",
        lineHeight: 1.65
      }}>{item.a}</AccordionDetails></Accordion></LandingReveal>;
}